import { useEffect, useState } from 'react';
import { flowResult } from 'mobx';
import { useStore } from '../../../core/utils/hook';
import ReactNotifications from '../../../components/Notifications/ReactNotifications';
import { MSG } from '../../../core/configs/constants';

/** @param {{ afterSaveSuccess?: () => void; enabled?: boolean }} [options] */
export function useMailNewsSubscriptionSettings(options = {}) {
    const { afterSaveSuccess, enabled = true } = options;
    const {
        userStore: { getProfile, profile, updateMailSettings }
    } = useStore();

    const [isSaving, setIsSaving] = useState(false);
    const [settings, setSettings] = useState({
        isSubscribedMonthlyNews: true,
        isSubscribedNewDrugMail: true,
        isSubscribedGuidelineMail: true
    });

    useEffect(() => {
        if (!enabled) return;
        getProfile();
    }, [enabled, getProfile]);

    useEffect(() => {
        if (!enabled || !profile) return;
        setSettings({
            isSubscribedMonthlyNews: profile?.isSubscribedMonthlyNews !== false,
            isSubscribedNewDrugMail: profile?.isSubscribedNewDrugMail !== false,
            isSubscribedGuidelineMail: profile?.isSubscribedGuidelineMail !== false
        });
    }, [profile]);

    const handleToggle = (key) => {
        if (isSaving) return;
        setSettings((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const handleSave = async () => {
        if (isSaving) return;
        setIsSaving(true);
        try {
            const ok = await flowResult(
                updateMailSettings({
                    isSubscribedMonthlyNews: settings.isSubscribedMonthlyNews,
                    isSubscribedNewDrugMail: settings.isSubscribedNewDrugMail,
                    isSubscribedGuidelineMail: settings.isSubscribedGuidelineMail
                })
            );
            if (ok) {
                if (typeof afterSaveSuccess === 'function') {
                    afterSaveSuccess();
                } else {
                    ReactNotifications('success', MSG['inform.success.update']);
                }
                getProfile();
            } else {
                ReactNotifications('error', MSG['api.response.server_error']);
            }
        } catch {
            ReactNotifications('error', MSG['api.response.server_error']);
        } finally {
            setIsSaving(false);
        }
    };

    return { settings, handleToggle, handleSave, isSaving };
}
